// 行事曆畫面共用的小工具
import type { PLATFORMS } from '@dayone/core/dictionaries';
import { parseReleaseDate } from '@dayone/core/release-date';
import type { CalendarEvent } from '../../calendar/status.ts';
import { t } from '../../i18n/zh-TW.ts';
import { formatRelease } from '../../lib/format.ts';

/** 2026-09-22 → 9/22（二） */
export function shortDay(date: string, currentYear: number): string {
  const r = parseReleaseDate(date);
  return r ? formatRelease(r, currentYear) : date;
}

/** 行事曆活動的日期：一天時 9/22（二）；日期未確定的活動是一段期間，例如 9/25（五）～12/31（四） */
export function spanText(start: string, end: string | undefined, currentYear: number): string {
  return end && end !== start
    ? t.gcal.span(shortDay(start, currentYear), shortDay(end, currentYear))
    : shortDay(start, currentYear);
}
export const eventWhen = (e: Pick<CalendarEvent, 'date' | 'end'>, currentYear: number) =>
  spanText(e.date, e.end, currentYear);

export function platformNames(keys: readonly string[]): string {
  return keys.map((k) => t.platforms[k as (typeof PLATFORMS)[number]['key']] ?? k).join('、');
}

export const messageText = (code: string) => t.gcal.messages[code] ?? t.gcal.messages.unknown;
